import React, { useState, useEffect, useRef } from 'react';
import './SubMenuBar.css';

const SubMenuBar = ({ menus }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveMenu(null);
        setActiveSubmenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMenuClick = menuKey => {
    // Call onOpen callback when a menu is opened (not when it's closed)
    if (activeMenu !== menuKey && menus[menuKey].onOpen) {
      menus[menuKey].onOpen();
    }
    
    setActiveMenu(activeMenu === menuKey ? null : menuKey);
    setActiveSubmenu(null);
  };

  const handleSubmenuClick = (menuKey, submenuKey) => {
    setActiveSubmenu(activeSubmenu === submenuKey ? null : submenuKey);
  };

  const handleItemClick = (menuKey, item, isSubmenu = false) => {
    if (isSubmenu) {
      menus[menuKey].submenus[activeSubmenu].onSelect(item);
    } else {
      menus[menuKey].onSelect(item);
    }
    setActiveMenu(null);
    setActiveSubmenu(null);
  };

  return (
    <div className="submenu-bar" ref={menuRef}>
      <div className="submenu-menugroup">
        {Object.entries(menus).map(([key, menu]) => (
          <div key={key} className="menu-container">
            <button
              className={`menu-button ${activeMenu === key ? 'active' : ''}`}
              onClick={() => handleMenuClick(key)}
            >
              {menu.label}
            </button>
            {activeMenu === key && (
              <div className="menu-items">
                {menu.items.map(item => (
                  <div key={item} className="menu-item-container">
                    <button
                      className={`menu-item ${
                        (Array.isArray(menu.selected) 
                          ? menu.selected.includes(item) 
                          : item === menu.selected)
                        ? 'selected' : ''
                      }`}
                      onClick={() => {
                        if (menu.submenus && menu.submenus[item]) {
                          handleSubmenuClick(key, item);
                        } else {
                          handleItemClick(key, item);
                        }
                      }}
                    >
                      {item}
                      {menu.submenus && menu.submenus[item] && ' ▸'}
                    </button>
                    {activeSubmenu === item && menu.submenus && menu.submenus[item] && (
                      <div className="submenu-items">
                        {menu.submenus[item].items.map(subItem => (
                          <button
                            key={subItem}
                            className={`submenu-item ${subItem === menu.submenus[item].selected ? 'selected' : ''}`}
                            onClick={() => handleItemClick(key, subItem, true)}
                          >
                            {subItem}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubMenuBar;
